import React, { useEffect, useState } from "react";
import inventoryAPI from "../../../api/inventory/inventoryApi";
import StockUpdateModal from "./StockUpdateModal";

function LowStockAlerts({ alerts: externalAlerts, onRefresh }) {
  const [internalAlerts, setInternalAlerts] = useState([]);
  const [dismissed, setDismissed] = useState(new Set());
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("quick");
  const [initialItem, setInitialItem] = useState(null);

  useEffect(() => {
    if (!externalAlerts) {
      inventoryAPI
        .getAlerts({ limit: 20 })
        .then((res) => setInternalAlerts(res.data || []));
    }
  }, [externalAlerts]);

  const alerts = externalAlerts || internalAlerts;
  const visibleAlerts = alerts.filter((a) => !dismissed.has(a.id));

  const handleAddStock = (item, type) => {
    setInitialItem(item);
    setModalMode(type);
    setModalOpen(true);
  };

  const handleDismiss = (id) => {
    setDismissed((prev) => new Set([...prev, id]));
  };

  const handleSuccess = () => {
    setModalOpen(false);
    onRefresh?.();
    // Refresh internal alerts
    if (!externalAlerts) {
      inventoryAPI
        .getAlerts({ limit: 20 })
        .then((res) => setInternalAlerts(res.data || []));
    }
  };

  if (visibleAlerts.length === 0) return null;

  return (
    <>
      {visibleAlerts.map((item) => (
        <div
          key={item.id}
          className="alert bg-orange-transparent alert-dismissible fade show mb-2"
        >
          <div>
            <i className="ti ti-info-circle fs-14 text-primary me-2" />
            <span>Your Product </span>
            <span className="text-primary fw-semibold">
              {item.productName}{" "}
              {item.variantName ? `(${item.variantName})` : ""}
              {item.sku ? `(${item.sku})` : ""}
            </span>
            <span> is running low at </span>
            <span className="fw-semibold">
              {item.locationName || "this location"}
            </span>
            <span> — only </span>
            <span className="fw-semibold text-primary">
              {item.currentStock} left
            </span>
            <span> (alert at {item.alertQuantity}).</span>

            <div className="mt-2 d-flex gap-2 flex-wrap">
              <a
                className="text-primary fw-semibold"
                onClick={() => handleAddStock(item, "quick")}
                data-id={item.id}
              >
                Add Stock
              </a>
              |
              <a
                className="text-secondary fw-semibold"
                onClick={() => handleAddStock(item, "pi")}
                data-id={item.id}
              >
                Create PI
              </a>
            </div>
          </div>
          <button
            type="button"
            className="btn-close text-gray-9 fs-14"
            onClick={() => handleDismiss(item.id)}
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
      ))}

      <StockUpdateModal
        isOpen={modalOpen}
        mode={modalMode}
        initialItem={initialItem}
        defaultLocationId={initialItem?.wareHouse}
        onClose={() => setModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
}

export default LowStockAlerts;
